import { NavLink, Outlet } from "react-router-dom"
import { Layout } from "./Layout"

// Primary tabs lead (Templates + Stats are the day-to-day tools); the secondary
// pair (Log + Setup) sits after a divider, visually de-emphasized — available,
// not foregrounded. Stats is the section's default landing (see App.tsx).
const PRIMARY_TABS = [
  { name: "Compose", to: "/email/compose" },
  { name: "Stats", to: "/email/stats" },
  { name: "Templates", to: "/email/templates" },
]
const SECONDARY_TABS = [
  { name: "Log", to: "/email/log" },
  { name: "Setup", to: "/email/setup" },
]

function tabClass(isActive: boolean, muted: boolean): string {
  const base = "whitespace-nowrap border-b-2 px-1 pb-3 text-sm transition-colors"
  if (isActive) return `${base} border-primary font-semibold text-primary`
  const idle = muted ? "text-secondary/70" : "text-secondary"
  return `${base} border-transparent font-medium ${idle} hover:text-primary`
}

/**
 * Shell for the admin Email section: section header + a tabbed sub-nav, with
 * each tab's page rendered into the <Outlet />. The only place the "Email"
 * identity/header lives — the sub-pages render content-only.
 */
export function EmailLayout() {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-primary">Email</h1>
          <p className="text-secondary">
            Deliverability stats, the templates we send, the full send log, and how Playside email
            is wired.
          </p>
        </div>

        <div className="border-b border-border">
          <nav className="-mb-px flex items-center gap-6">
            {PRIMARY_TABS.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) => tabClass(isActive, false)}
              >
                {tab.name}
              </NavLink>
            ))}
            <span className="h-4 w-px self-center bg-border" aria-hidden="true" />
            {SECONDARY_TABS.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) => tabClass(isActive, true)}
              >
                {tab.name}
              </NavLink>
            ))}
          </nav>
        </div>

        <Outlet />
      </div>
    </Layout>
  )
}
